"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: frontend/static/images/share-icons/x.svg
var XSocial = function XSocial(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _preact.h)("path", {
    d: "M3.49995 1.69995C2.50714 1.69995 1.69995 2.50714 1.69995 3.49995V12.5C1.69995 13.4928 2.50714 14.3 3.49995 14.3H12.5C13.4928 14.3 14.3 13.4928 14.3 12.5V3.49995C14.3 2.50714 13.4928 1.69995 12.5 1.69995H3.49995ZM11.8559 4.06245L8.93651 7.39808L12.3706 11.9375H9.68183L7.57808 9.18401L5.16776 11.9375H3.83183L6.9537 8.36839L3.66026 4.06245H6.41651L8.32058 6.57964L10.52 4.06245H11.8559ZM10.7928 11.1387L6.01433 4.81901H5.21839L10.0503 11.1387H10.7928Z",
    fill: "black"
  }));
};

var _default = XSocial;
exports.default = _default;